import React from 'react';
import { MapContainer } from 'react-leaflet';
import { MContainer } from './map-container';

export function MapComponent(props) {
    const { setMap, styles, location } = props;

    return (
        <div style={styles}>
            <MapContainer
                scrollWheelZoom={true}
                className="map"
                maxZoom={17}
                closePopupOnClick
                whenCreated={setMap}
            >
                <MContainer location={location} />
            </MapContainer>
        </div>
    );
}
